/**
 * Keeps the free shipping line (blocks/birrot-free-shipping.liquid) on the
 * selected variant. Horizon morphs only the variant picker on a size change;
 * this takes the block's new children from the section the productSelect
 * event re-rendered, as product-price.js does.
 */

import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class BirrotFreeShipping extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section')?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /** @param {import('@shopify/events').ProductSelectEvent} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        const fresh = detail?.html?.querySelector(`birrot-free-shipping[data-block-id="${this.dataset.blockId}"]`);
        if (!fresh) return;
        this.replaceChildren(...fresh.childNodes);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[birrot-free-shipping] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('birrot-free-shipping')) {
  customElements.define('birrot-free-shipping', BirrotFreeShipping);
}
